import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        //Promo Slider
        container: {
            maxW: remCalc(1920),
            py: {base: remCalc(16), md: remCalc(40)},
            position: 'relative',
            margin: '0 auto',
            overflow: 'hidden',
            '@media screen and (min-width: 450px) and (max-width: 767px)': {
                // paddingTop: remCalc(16),
                // paddingBottom: remCalc(16)
                py: remCalc(16),
            },
        },
        videoTitle: {
            textStyle: 'head-large',
            fontWeight: '500',
            w: '100%',
            textAlign: 'center',
            color: 'text.default',
        },
        chevronIcon: {
            width: {base: remCalc(24), md: remCalc(32), lg: remCalc(40)},
            height: {base: remCalc(24), md: remCalc(32), lg: remCalc(40)},
            position: 'absolute',
            top: {base: '30%', md: '50%'},
            transform: 'translateY(-100%)',
            backgroundColor: 'background.default',
            borderRadius: '50%',
            border: 'small',
            borderStyle: 'solid',
            cursor: 'pointer',
            zIndex: '10',
            '@media screen and (min-width: 450px) and (max-width: 767px)': {
                width: remCalc(32),
                height: remCalc(32),
                top: '50%',
            },
        },
        heading: {
            textAlign: 'center',
            px: remCalc(24),
            py: {base: remCalc(16), md: remCalc(40)},
            textStyle: ['head-large'],
            fontWeight: '500',
            color: 'text.default',
        },
        sliderContainer: {
            mx: {base: remCalc(16), md: 'unset'},
            position: 'relative',
            flexDirection: {base: 'column', md: 'row'},
            alignItems: 'center',
            cursor: 'auto',
            '@media screen and (min-width: 450px) and (max-width: 767px)': {
                mx: 'unset',
                flexDirection: 'row',
            },
        },
        imageContainer: {
            width: {base: '100%', md: '50%'},
            flexShrink: '1',
            height: {base: '100%', md: remCalc(456), lg: remCalc(520)},
            overflow: 'hidden',
            '@media screen and (min-width: 450px) and (max-width: 767px)': {
                width: '50%',
                height: remCalc(456),
            },
        },
        contentContainer: {
            width: {base: '100%', md: '50%'},
            flexShrink: '0',
            // overflow: 'auto',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            height: {base: remCalc(334), md: remCalc(456), lg: remCalc(520)},
            backgroundColor: 'background.brand',
            px: {base: remCalc(24), md: remCalc(40), lg: remCalc(40)},
            py: {base: remCalc(24), md: remCalc(61), lg: remCalc(51), xl: remCalc(126)},
            '@media screen and (min-width: 450px) and (max-width: 767px)': {
                width: '50%',
                height: remCalc(456),
                px: remCalc(40),
                py: remCalc(51),
            },
        },
        //PromoSliderImage
        promoSlideImageContainer: {
            mx: {base: remCalc(16), md: 'unset'},
            cursor: 'auto',
        },
        promoSlideBackground: {
            overflow: 'hidden',
            _before: {
                content: '""',
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                bg: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6))',
                zIndex: '0',
            },
            bgSize: 'cover',
            bgPos: 'center',
            bgRepeat: 'no-repeat',
            w: '100%',
            maxW: {md: remCalc(642), lg: remCalc(926)}, // base: remCalc(343)
            height: {base: remCalc(239), md: remCalc(320), lg: 'auto'},
            maxHeight: {lg: remCalc(520)},
            position: 'relative',
            '@media screen and (min-width: 450px) and (max-width: 767px)': {
                maxW: remCalc(598),
                h: remCalc(380),
            },
        },
        promoSlideBackgroundImage: {
            height: {base: remCalc(442), md: remCalc(456), xl: remCalc(520)},
        },
        promoSliderContent: {
            flexDirection: 'column',
            alignItems: 'center',
            position: 'absolute',
            bottom: remCalc(40),
            align: 'center',
            w: '100%',
            maxW: {base: remCalc(285), md: remCalc(476), lg: remCalc(688)},
            left: '50%',
            transform: 'translateX(-50%)',
            '@media screen and (min-width: 450px) and (max-width: 767px)': {
                maxW: remCalc(476),
            },
        },
        // PromoSliderVideo
        promoSliderVideoContainer: {
            position: 'relative',
            width: '100%',
            maxWidth: {md: remCalc(640), lg: remCalc(688)},
            height: {base: remCalc(239), md: remCalc(320), lg: remCalc(369), xl: remCalc(415)},
            overflow: 'hidden',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            _before: {
                content: '""',
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                bg: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5))',
                zIndex: '0',
                pointerEvents: 'none',
            },
        },
        playIconContainer: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: '2',
        },
        playIcon: {
            width: '40px',
            height: '40px',
            fill: 'white',
        },
        contentOverlay: {
            display: {base: 'none', md: 'none', lg: 'block'},
            position: 'absolute',
            width: '100%',
            pointerEvents: 'auto',
            bottom: {lg: remCalc(45)},
            py: {lg: remCalc(35)},
            textAlign: 'center',
        },
        content: {
            flexDirection: 'column',
            alignItems: 'center',
            gap: {base: remCalc(24)},
            pt: remCalc(24),
            pointerEvents: 'none',
        },
        label: {
            textStyle: 'body-small',
            color: {base: 'text.secondary', md: 'text.secondary', lg: 'text.inverse'},
            pb: {lg: remCalc(24)},
            fontWeight: '700',
        },
        title: {
            textStyle: ['head-large'],
            fontWeight: '500',

            color: {base: 'text.default', md: 'text.default', lg: 'text.inverse'},
        },
    },
    variants: {
        paperlessVariant: {
            promoSliderVideoContainer: {
                height: {base: '100vw', md: remCalc(320), lg: remCalc(369), xl: remCalc(415)},
            },
            content: {
                position: 'absolute',
                bottom: '15%',
                left: '50%',
                transform: 'translateX(-50%)',
                color: 'text.inverse',
                width: '100%',
                textAlign: 'center',
            },
            label: {
                color: {sm: 'text.inverse', md: 'text.inverse'},
            },
            title: {
                textStyle: {base: 'head-small', md: 'head-large'},
                color: {base: 'text.inverse', md: 'text.inverse'},
            },
        },
    },
}
